import type { Question } from "../types/onboarding";

export function isSetupProfileQuestion(
	question: Question,
): question is Question & { type: "setup-profile" } {
	return question.type === "setup-profile";
}

export function isSetupProfileDetailsQuestion(
	question: Question,
): question is Question & { type: "setup-profile-details" } {
	return question.type === "setup-profile-details";
}

export function isFertilityStatusQuestion(
	question: Question,
): question is Question & { type: "fertility-status" } {
	return question.type === "fertility-status";
}

export function isFertilityRoleQuestion(
	question: Question,
): question is Question & { type: "fertility-role" } {
	return question.type === "fertility-role";
}

export function isFertilityJourneyTypesQuestion(
	question: Question,
): question is Question & { type: "fertility-journey-types" } {
	return question.type === "fertility-journey-types";
}

export function isNeedsMostQuestion(
	question: Question,
): question is Question & { type: "needs-most" } {
	return question.type === "needs-most";
}

export function isHowDidYouHearQuestion(
	question: Question,
): question is Question & { type: "how-did-you-hear" } {
	return question.type === "how-did-you-hear";
}

export function isProfileSelectQuestion(
	question: Question,
): question is Question & { type: "profile-select" } {
	return question.type === "profile-select";
}

export function isPersonalInfoQuestion(
	question: Question,
): question is Question & { type: "personal-info" } {
	return question.type === "personal-info";
}

export function isGenderRelationshipQuestion(
	question: Question,
): question is Question & { type: "gender-relationship" } {
	return question.type === "gender-relationship";
}

export function isFertilityPathQuestion(
	question: Question,
): question is Question & { type: "fertility-path" } {
	return question.type === "fertility-path";
}

export function isInterestsQuestion(
	question: Question,
): question is Question & { type: "interests" } {
	return question.type === "interests";
}

export function isSelectProviderQuestion(
	question: Question,
): question is Question & { type: "select-provider" } {
	return question.type === "select-provider";
}

export function isAdditionalInfoQuestion(
	question: Question,
): question is Question & { type: "additional-info" } {
	return question.type === "additional-info";
}

export function getQuestionTypeName(question: Question): string {
	switch (question.type) {
		case "setup-profile":
			return "Setup Profile";
		case "setup-profile-details":
			return "Setup Profile Details";
		case "fertility-status":
			return "Fertility Status";
		case "fertility-role":
			return "Fertility Role";
		case "fertility-journey-types":
			return "Fertility Journey Types";
		case "needs-most":
			return "Needs Most";
		case "how-did-you-hear":
			return "How Did You Hear";
		case "profile-select":
			return "Profile Selection";
		case "personal-info":
			return "Personal Information";
		case "gender-relationship":
			return "Gender & Relationship";
		case "fertility-path":
			return "Fertility Path";
		case "interests":
			return "Interests";
		case "select-provider":
			return "Provider Selection";
		case "additional-info":
			return "Additional Information";
		default:
			return "Unknown Question Type";
	}
}

export function requiresValidation(question: Question): boolean {
	return (
		isPersonalInfoQuestion(question) ||
		isSetupProfileQuestion(question) ||
		isSetupProfileDetailsQuestion(question) ||
		isFertilityStatusQuestion(question) ||
		isFertilityRoleQuestion(question) ||
		isFertilityJourneyTypesQuestion(question) ||
		isNeedsMostQuestion(question) ||
		isHowDidYouHearQuestion(question)
	);
}

export function hasOptions(
	question: Question,
): question is Question & { options: NonNullable<Question["options"]> } {
	return question.options !== undefined && question.options.length > 0;
}

export function hasFields(
	question: Question,
): question is Question & { fields: NonNullable<Question["fields"]> } {
	return question.fields !== undefined && question.fields.length > 0;
}
